import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/components/metrics-legend.css';

// Import icon assets
import { ReactComponent as FlussoIcon } from '../../../Assets/icons/flusso.svg';
import { ReactComponent as CodaMediaIcon } from '../../../Assets/icons/coda_media.svg';
import { ReactComponent as RitardoMedioIcon } from '../../../Assets/icons/ritardo_medio.svg';

const MetricsLegend = ({ flusso, codaMedia, ritardoMedio, visible = true, className = '', position = 'left' }) => {
  if (!visible) return null;

  return (
    <div className={`metrics-legend-panel position-${position} ${className}`}>
      <div className="legend-metrics">
        <div className="metric-item">
          <div className="metric-icon-wrapper">
            <FlussoIcon className="metric-icon" />
          </div>
          <div className="metric-info">
            <span className="metric-label">Flusso</span>
            <span className="metric-value">{flusso} Veic/H</span>
          </div>
        </div>
        <div className="metric-item">
          <div className="metric-icon-wrapper">
            <CodaMediaIcon className="metric-icon" />
          </div>
          <div className="metric-info">
            <span className="metric-label">Coda Media</span>
            <span className="metric-value">{codaMedia} Veic</span>
          </div>
        </div>
        <div className="metric-item">
          <div className="metric-icon-wrapper">
            <RitardoMedioIcon className="metric-icon" />
          </div>
          <div className="metric-info">
            <span className="metric-label">Ritardo Medio</span>
            <span className="metric-value">{ritardoMedio} Sec/Km</span>
          </div>
        </div>
      </div>
    </div>
  );
};

MetricsLegend.propTypes = {
  flusso: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  codaMedia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ritardoMedio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  visible: PropTypes.bool,
  className: PropTypes.string,
  position: PropTypes.oneOf(['left', 'right'])
};

export default MetricsLegend;